function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 21,
  r: 21,
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 4,
  y1: 59.5,
  x2: 297,
  y2: 59.5,
  stroke: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.64645 78.3536C3.84171 78.5488 4.15829 78.5488 4.35355 78.3536L7.53553 75.1716C7.7308 74.9763 7.7308 74.6597 7.53553 74.4645C7.34027 74.2692 7.02369 74.2692 6.82843 74.4645L4 77.2929L1.17157 74.4645C0.976311 74.2692 0.659729 74.2692 0.464467 74.4645C0.269205 74.6597 0.269205 74.9763 0.464467 75.1716L3.64645 78.3536ZM3.5 60L3.5 78L4.5 78L4.5 60L3.5 60Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M296.646 78.3536C296.842 78.5488 297.158 78.5488 297.354 78.3536L300.536 75.1716C300.731 74.9763 300.731 74.6597 300.536 74.4645C300.34 74.2692 300.024 74.2692 299.828 74.4645L297 77.2929L294.172 74.4645C293.976 74.2692 293.66 74.2692 293.464 74.4645C293.269 74.6597 293.269 74.9763 293.464 75.1716L296.646 78.3536ZM296.5 60L296.5 78L297.5 78L297.5 60L296.5 60Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  x1: 146.5,
  y1: 60,
  x2: 146.5,
  y2: 44,
  stroke: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M153.56 24.38C151.477 22.3544 148.686 21.2211 145.78 21.2211C142.874 21.2211 140.083 22.3544 138 24.38",
  stroke: "white",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.56 8H145C141.134 8 138 11.134 138 15V27.02C138 30.886 141.134 34.02 145 34.02H146.56C150.426 34.02 153.56 30.886 153.56 27.02V15C153.56 11.134 150.426 8 146.56 8Z",
  stroke: "white",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.35 13.3C147.35 12.3777 146.602 11.63 145.68 11.63C144.758 11.63 144.01 12.3777 144.01 13.3V15.93C144.01 16.8523 144.758 17.6 145.68 17.6C146.602 17.6 147.35 16.8523 147.35 15.93V13.3Z",
  stroke: "white",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.68 8V11.63",
  stroke: "white",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.68 17.6V21.2",
  stroke: "white",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 17.56,
  height: 28.02,
  fill: "white",
  transform: "translate(137 7)"
})));

function SvgScrollDownTree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 79,
    viewBox: "0 0 311 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollDownTree);
export default __webpack_public_path__ + "static/media/scrollDownTree.c70ba090.svg";
export { ForwardRef as ReactComponent };